/* Publish by EComposer at 2026-10-27 03:18:52*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-k9vo11d13jf"]=  window.__ectimmers["ecom-k9vo11d13jf"] || {};
var e=this.$el;if(e&&this.isLive){var t=e.querySelectorAll(".element-social-link:not(.element-social-link__custom)");t.length&&t.forEach(function(i){var a=i.getAttribute("href")||"#",r=a.replace("{current-link}",location.href);i.setAttribute("href",r)})}

                    });
                    
                        document.querySelectorAll('.ecom-k9vo11d13jf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k9vo11d13jf', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-lgqrz148zd"]=  window.__ectimmers["ecom-lgqrz148zd"] || {};
let e=this.$el.querySelector(".ecom-shopify__article__description-view-more-btn"),r=this.settings.content_type,s=this.$el.querySelector(".ecom-shopify__article__description--full"),l=this.$el.querySelector(".ecom-shopify__article__description--paragraph");e&&e.addEventListener("click",function(){r==="text"&&s?(s.style.display="inherit",l.style.display="none"):l.style.maxHeight=null,this.style.display="none"})

                    });
                    
                        document.querySelectorAll('.ecom-lgqrz148zd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lgqrz148zd', settings: {"content_type":"html"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}